/* eslint-disable no-underscore-dangle */
import 'core-js/es/promise'; // For IE 11 support
import 'core-js/es/array'; // For IE 11 support
import 'core-js/es/object/assign'; // For IE 11 support
import 'core-js/es/object/entries'; // For IE 11 support
import 'core-js/es/string/starts-with'; // For IE 11 support
import 'core-js/es/string/ends-with'; // For IE 11 support
import 'core-js/es/string/includes'; // For IE 11 support
import 'core-js/es/number/parse-int'; // For IE11 support (in ReactDOM)
import React from 'react';
import thunk from 'redux-thunk';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import '@homeaway/edap-integrations';
import '../../node_modules/@homeaway/stab-analytics-polyfill/release/javascripts/stab-analytics-polyfill.min';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { routerMiddleware } from 'connected-react-router';
import StorageMiddleware from '@homeaway/redux-local-storage-middleware';
import TagManager from 'react-gtm-module';
import { loadableReady } from '@loadable/component';
import { createClientSideReducer } from '../universal/reducers';
import App, { history } from '../universal/components/App/ClientApp';
import ValidationMiddleware from '../universal/middleware/validation';
import { generateApolloClient } from '../universal/utils/GqlUtil';
import './XDID';
import HydrationActions from '../universal/actions/hydration';
import { EdapEventProvider, GtmEventProvider } from '../universal/utils/EventProviders';

// Simple polyfill for isNan on ie11
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
Number.isNaN = Number.isNaN || function isNaN(input) {
    // eslint-disable-next-line no-self-compare
    return typeof input === 'number' && input !== input;
};

const initialState = window.__INITIAL_STATE__;

const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const localStorage = new StorageMiddleware({ storageKey: 'ulx-storage' });

const middleware = [
    thunk,
    routerMiddleware(history),
    ...ValidationMiddleware,
    localStorage.generateMiddleware()
];

const enhancer = composeEnhancers(
    applyMiddleware(...middleware)
);

const store = createStore(
    createClientSideReducer(history),
    initialState,
    enhancer
);

const apolloOptions = {};
if (typeof window === 'object' && window.ha && window.ha.siteName) {
    // Use both site and siteName because different tools use one or the other.
    apolloOptions.queryParams = {
        siteName: window.ha.siteName,
        site: window.ha.siteName
    };
}
const client = generateApolloClient(apolloOptions);

function initGtmOptimize() {
    const script = document.createElement('script');

    script.src = 'https://www.googleoptimize.com/optimize.js?id=OPT-56VZX44';
    script.defer = true;
    script.onError = 'dataLayer.hide.end && dataLayer.hide.end()';

    document.body.appendChild(script);
    // eslint-disable-next-line no-unused-vars, func-names
    (function (a, s, y, n, c, h, i, d, e) {
        // eslint-disable-next-line no-param-reassign
        s.className += ` ${y}`; h.start = 1 * new Date();
        // eslint-disable-next-line no-param-reassign,no-multi-assign, func-names
        h.end = i = function () { s.className = s.className.replace(RegExp(` ?${y}`), ''); };
        // eslint-disable-next-line no-param-reassign
        (a[n] = a[n] || []).hide = h; setTimeout(() => { i(); h.end = null; }, c); h.timeout = c;
    }(window, document.documentElement, 'async-hide', 'dataLayer', 4000,
        { 'OPT-56VZX44': true }));
}

let SwitchedProvider = EdapEventProvider;

if (initialState.app.features.isConventionalLodgingFlow) {
    const tagManagerArgs = {
        gtmId: 'GTM-KDZW85F',
        dataLayerName: 'dataLayer'
    };

    TagManager.initialize(tagManagerArgs);
    TagManager.dataLayer(tagManagerArgs);
    initGtmOptimize();
    SwitchedProvider = GtmEventProvider;
}

if (!initialState.app.features.useEdap) {
    if (typeof window === 'object') {
        // Ideally we would conditionally load edap, but in orderr
        // to do that we would have to refactor this file, the webpack
        // code, and the edapUtils code. This bypasses all of that.
        // We can come back and refactor later if we wish to.
        window.edap.trigger = () => {}; // eat any triggered events.
    }
}

loadableReady(() => {
    ReactDOM.hydrate(
        <ApolloProvider client={client}>
            <Provider store={store}>
                <SwitchedProvider>
                    <App />
                </SwitchedProvider>
            </Provider>
        </ApolloProvider>,
        document.getElementById('root')
    );
});

localStorage.replayActions(store);
// Let the app know we are done hydrating.
store.dispatch(HydrationActions.setHydrationComplete());
